<div class="container">
    <app-guest-email></app-guest-email>
</div>
<hr>

<div *ngIf="guestService">
    <!-- Submitting or changing names can be done only when guest has given his email-->
    <app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>
    <!--guest routes: manage names, submit name, and settings-->
    <router-outlet (activate)="changeOfRoutes()"></router-outlet>
</div>